import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import Customers from "@/pages/Customers";
import Templates from "@/pages/Templates";
import Schedule from "@/pages/Schedule";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";
import AccurateCallback from "@/pages/AccurateCallback";
import SyncLogs from "@/pages/SyncLogs";
import Diagnostics from "@/pages/Diagnostics";
import Layout from "@/components/Layout";

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/oauth/accurate/callback" element={<AccurateCallback />} />
          <Route path="/" element={<Layout><Dashboard /></Layout>} />
          <Route path="/invoices" element={<Layout><Invoices /></Layout>} />
          <Route path="/customers" element={<Layout><Customers /></Layout>} />
          <Route path="/templates" element={<Layout><AdminRoute><Templates /></AdminRoute></Layout>} />
          <Route path="/schedule" element={<Layout><AdminRoute><Schedule /></AdminRoute></Layout>} />
          <Route path="/logs" element={<Layout><Logs /></Layout>} />
          <Route path="/settings" element={<Layout><AdminRoute><Settings /></AdminRoute></Layout>} />
          <Route path="/sync-logs" element={<Layout><AdminRoute><SyncLogs /></AdminRoute></Layout>} />
          <Route path="/diagnostics" element={<Layout><AdminRoute><Diagnostics /></AdminRoute></Layout>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;

